import ImgAnggrek from './anggrek.png';
import ImgAngkasatu from './angkasatu.png';
import ImgAnissaCatering from './annisa.png';
import astungkara from './astungkara.png';
import ayu from './ayu.png';
import diahkharisma from './diahkharisma.png';
import feeMua from './fee-mua.jpg';
import idacatering from './idacatering.png';
import jamil from './jamil.png';
import omahQ from './omah-q-wo.png';
import patra from './patra.png';
import sonokembang from './sonokembang.png';
import paragon from './paragon.png';
import sadewa from './sadewa.png';
import myteam from './myteam.png';
import rejata from './rejata.png';
import pandanwangi from './pandanwangi.png';
import kusuma from './kusuma.png';
import tiara from './tiara.png';
import riens from './riens.png';
import plumeria from './plumeria.png';
import flatter from './flatter.png';
import denar from './denar.png';
import kingdom from './kingdom.png';
import { LOGO_INVITATO } from '@/constants/assets';
import bozze from '../support/4.png';
import svarga from '../assets/svarga.png';
import kerutwajah from '../assets/kerutwajah.png';

export const DATA_VENDOR = [
  {
    title: 'Anggrek Catering',
    imgUrl: ImgAnggrek,
  },
  {
    title: 'Angkasatu Decoration',
    imgUrl: ImgAngkasatu,
  },
  {
    title: 'Annisa Catering',
    imgUrl: ImgAnissaCatering,
  },
  {
    title: 'Astungkara',
    imgUrl: astungkara,
  },
  {
    title: 'Ayu Prasanti - Souvenir',
    imgUrl: ayu,
  },
  {
    title: 'Diah Kharisma Decoration',
    imgUrl: diahkharisma,
  },
  {
    title: 'FEE MUA',
    imgUrl: feeMua,
  },
  {
    title: 'IDA CATERING',
    imgUrl: idacatering,
  },
  {
    title: 'JAMIL JEWELRY',
    imgUrl: jamil,
  },
  {
    title: 'OMAH Q WO',
    imgUrl: omahQ,
  },
  {
    title: 'Invitato - Wedding Website Invitation',
    imgUrl: LOGO_INVITATO,
  },
  {
    title: 'HOTEL & CONVENTION - PARTA SEMARANG',
    imgUrl: patra,
  },
  {
    title: 'SONOKEMBANG CATERING',
    imgUrl: sonokembang,
  },
  {
    title: 'PARAGON MAKEOVER',
    imgUrl: paragon,
  },
  {
    title: 'SADEWA WO',
    imgUrl: sadewa,
  },
  {
    title: 'MY TEAM DECORATION',
    imgUrl: myteam,
  },
  {
    title: 'REJATA BAND',
    imgUrl: rejata,
  },
  {
    title: 'PANDANWANGI',
    imgUrl: pandanwangi,
  },
  {
    title: 'KUSUMA ASRI',
    imgUrl: kusuma,
  },
  {
    title: 'TIARA TRADITIONAL WO',
    imgUrl: tiara,
  },
  {
    title: 'RIENS DECORATION',
    imgUrl: riens,
  },
  {
    title: 'PLUMERIA',
    imgUrl: plumeria,
  },
  {
    title: 'FLATTER',
    imgUrl: flatter,
  },
  {
    title: 'DENAR KUSUMA',
    imgUrl: denar,
  },
  {
    title: 'KINGDOM SOUND & LIGHTING',
    imgUrl: kingdom,
  },
  {
    title: 'BOZZE',
    imgUrl: bozze,
  },
  {
    title: 'SVARGA SOUVENIR',
    imgUrl: svarga,
  },
  {
    title: 'KERUT WAJAH PHOTOGRAPHY',
    imgUrl: kerutwajah,
  },
]